import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Evenings lost searching for progressions that actually work, flow logically and match your student’s specific level', 'Sessions that feel repetitive — because you keep returning to the same drills and positions you already know', 'Visible improvisation that silently erodes your confidence as an instructor', 'Little variety between weeks — and students who gradually lose motivation without knowing exactly why', 'Weekends spent planning instead of resting, recharging or living your life'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-carbon" data-id="element-223" data-mp="1o0d4za3mzqs0">
      <div className="max-w-3xl mx-auto" data-id="element-224" data-mp="1o1o8r9x30yj4">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-225" data-mp="1sxv8gkyvxdsm">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-white" data-id="element-226" data-mp="3nd7k1v5uyivy">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-mist leading-relaxed bg-carbon-graphite p-6 rounded-2xl border border-carbon-line text-left space-y-4" data-id="element-227" data-mp="1yz3y31ns6aif">
            <p data-id="element-228" data-mp="27sqqchss4vmv">
              Sunday evening. 10 PM. You have a BJJ class tomorrow morning. And
              you&apos;re still here — searching online, trying to build a
              session structure that actually flows — one that matches your
              student&apos;s level, feels professional and doesn&apos;t look
              like it was thrown together in twenty minutes.
            </p>
            <p data-id="element-229" data-mp="1p2914n75oi69">
              <span className="text-white font-semibold" data-id="element-230" data-mp="1p2r5k73z22p9">
                Not because you don&apos;t know Brazilian Jiu Jitsu.
              </span>{' '}
              Because nobody ever gave you a complete, structured,
              ready-to-teach library. You&apos;ve been building every single
              session from scratch.
            </p>
            <p data-id="element-231" data-mp="2vknpb8b4rt6k">
              The time you should be resting — you&apos;re spending planning.
              And the worst part isn&apos;t the exhaustion. The worst part is
              walking onto the mat feeling like you could have been better
              prepared.
            </p>
          </div>
        </motion.div>

        <div className="space-y-6" data-id="element-232" data-mp="274xwdplignxl">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-233" data-mp="273v7fn7r0vkb">
            The real cost of not having the right resource:
          </h3>
          <ul className="space-y-4" data-id="element-234" data-mp="1acuc4r17zm46">
            {painPoints.map(point => <li key={point} className="flex items-start gap-4 bg-carbon-graphite p-4 rounded-xl border border-carbon-line" data-id="element-235" data-mp="1egim1gdbqtsl">
                <span className="mt-2 w-2 h-2 rounded-full bg-gold shrink-0" aria-hidden="true" data-id="element-236" data-mp="1o73ppi7uuoid" />
                <span className="text-mist" data-id="element-237" data-mp="qpn02zvjust9">{point}</span>
              </li>)}
          </ul>
          <div className="text-center mt-12 pt-8 border-t border-gold/30" data-id="element-238" data-mp="vogbmmra09qs">
            <p className="text-2xl font-serif font-bold text-white" data-id="element-239" data-mp="o6ru2bdp9fvw">
              Stop giving away your free time. Your dedication is already there.
              What you need now is <span className="text-gold" data-id="element-240" data-mp="e82eip9a07it">the right tool.</span>
            </p>
            <p className="text-xl mt-4 text-mist" data-id="element-241" data-mp="ea5eo2457h19">
              Solve an entire year of BJJ classes in just 5 minutes.
            </p>
          </div>
        </div>
      </div>
    </section>;
}